import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { ImageSwitch } from 'components/imageSwitch'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const defaultProperties = {
    labelType: 'top',
    mobileImageUrl: '',
    desktopImageUrl: '',
    mobileImageUrlDark: '',
    desktopImageUrlDark: '',
    title: '',
    lead: '',
    width: 'text',
    caption: '',
    source: '',
  }
  const { mobileImageUrl, desktopImageUrl, mobileImageUrlDark, desktopImageUrlDark, title, lead, width, caption, source, labelType } = {
    ...defaultProperties,
    ...properties,
  }

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <ImageSwitch
        colorMode={colorMode}
        mobileImageUrl={mobileImageUrl}
        desktopImageUrl={desktopImageUrl}
        mobileImageUrlDark={mobileImageUrlDark}
        desktopImageUrlDark={desktopImageUrlDark}
        title={title}
        lead={lead}
        width={width as 'text' | 'article' | 'content' | 'full' | 'textextended' | 'textextendedfullmobile' | 'textfullmobile'}
        caption={caption}
        source={source}
        labelType={labelType as 'top' | 'bottom'}
      ></ImageSwitch>
    </AppContainer>
  )
}
const AppContainer = styled.div<{ tenant?: string }>`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  margin-bottom: 30px;
  font-family: var(--font-plex);
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
`
export default MainComponent
